import React from 'react';
import PropTypes from 'prop-types';
// Components
import { CatePaper, RedButton } from 'components';
import Traslate from 'i18n/traslate';
import ELEMENTS from 'constants/elementsForTranslate';

function MerdadoPagoCheckout(props) {
  const { isStorePickup, subTotal, deliveryPrice, handleSuccess, experiencepId } = props;
  let price = JSON.parse(localStorage.getItem('precio_envio_productos')) || 0;

  if (experiencepId) {
    return (
      <CatePaper disableElevation className="payment-overview">
        <div>
          <div className="overview-title">
            <h3>{Traslate(ELEMENTS.SHOPCART.SUMMARY)}</h3>
          </div>
          <div className="overview-body">
            <div className="price-group">
              <dl>
                <dt>Subtotal</dt>
                <dd>S/. {subTotal.toFixed(2)}</dd>
              </dl>
            </div>
          </div>
          <div className="overview-total">
            <dl>
              <dt>Total</dt>
              {isStorePickup ? (
                <dd>S/. {subTotal?.toFixed(2)}</dd>
              ) : (
                <dd>S/. {subTotal?.toFixed(2)}</dd>
              )}
            </dl>
          </div>
          <div className="overview-btn">
            <RedButton
              fullWidth
              disableElevation
              variant="contained"
              color="primary"
              onClick={handleSuccess}>
              {Traslate(ELEMENTS.SHIPPING.PAY)}
            </RedButton>
          </div>
        </div>
      </CatePaper>
    );
  }

  return (
    <CatePaper disableElevation className="payment-overview">
      <div>
        <div className="overview-title">
          <h3>{Traslate(ELEMENTS.SHOPCART.SUMMARY)}</h3>
        </div>
        <div className="overview-body">
          <div className="price-group">
            <dl>
              <dt>Subtotal</dt>
              <dd>S/. {subTotal.toFixed(2)}</dd>
            </dl>
          </div>
          <div className="price-group">
            <dl>
              <dt>Costo de envío</dt>
              {isStorePickup ? <dd>Retiro en tienda</dd> : <dd>S/. {price?.toFixed(2)}</dd>}
            </dl>
          </div>
        </div>
        <div className="overview-total">
          <dl>
            <dt>Total</dt>
            {isStorePickup ? (
              <dd>S/. {subTotal?.toFixed(2)}</dd>
            ) : (
              <dd>S/. {(subTotal + price)?.toFixed(2)}</dd>
            )}
          </dl>
        </div>
        <div className="overview-btn">
          <RedButton
            fullWidth
            disableElevation
            variant="contained"
            color="primary"
            onClick={handleSuccess}>
            {Traslate(ELEMENTS.SHIPPING.PAY)}
          </RedButton>
        </div>
      </div>
    </CatePaper>
  );
}

MerdadoPagoCheckout.propTypes = {
  subTotal: PropTypes.number,
  deliveryPrice: PropTypes.number,
  payment: PropTypes.number,
  handleSuccess: PropTypes.func.isRequired,
};

export default MerdadoPagoCheckout;
